<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ArgTitreCtaTexte'
});
</script>
<template>
  <ka-container
    code="arg-titre-cta-texte"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="nouvelle-annee-nouveaux">
      <span v-html="t('argTitreCtaTexte.nouvelleAnneeNouveaux.value', `Nouvelle année, nouveaux budgets !`)" />
    </ka-text>
    <ka-text
      code="text"
      :options="{
        style: {
          fontSize: $first([
            componentInstance.$textSize.value === `small` ? 0.5 : undefined,
            componentInstance.$textSize.value === `medium` ? 1 : undefined,
            1.5
          ]),
          fontSizeUnit: `rem`
        }
      }"
      :value="componentInstance.$text.value" />
    <ka-button
      code="prendre-rendez-vous"
      :options="{
        ripple: true,
        href: `https://meetings.hubspot.com/christophe-pramil`,
        ariaLabel: `button`,
        click: componentInstance.prendreRendezVousClick
      }">
      <span v-html="t('argTitreCtaTexte.prendreRendezVous.value', `Prendre rendez-vous`)" />
    </ka-button>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { argTitreCtaTexteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c22')
const component = argTitreCtaTexteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  text?: Nullable<string>
  textSize?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  text: 'Tenez-vous informés de l\'actualité formation, des financements et des conditions en vous <span style="color:#D93174FF;">inscrivant à notre newsletter. </span><br> <br>Si vous souhaitez tout savoir sans plus attendre, vous pouvez également prendre rendez-vous gratuitement avec Christophe pour de super conseils en formation et beaucoup d\'écoute👌',
  textSize: 'medium',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:text',
  'update:textSize'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    text: true,
    textSize: true
  }
})
</script>
